/**
 * Pack-relative asset path → the URL a shell fetches (D93, extracted D132).
 *
 * @remarks
 * A plate's `src`, a sprite's, a bed's, a logo's — every asset a pack names
 * is pack-relative, and only the SOURCE knows where the pack's files are
 * served (`RuntimeBundleManifest.assetBaseUrl`). Absent, the path passes
 * through verbatim: a pack with no assets, or a shell that serves them at
 * root. Three shell call sites carried this same conditional before the
 * title screen brought two more, which is past the threshold where a shape
 * is a fact rather than a coincidence (§13.1).
 *
 * @packageDocumentation
 */

/** The one field this needs — accepted structurally so callers can pass the whole runtime manifest. */
export interface AssetBaseCarrier {
	readonly assetBaseUrl?: string;
}

/**
 * Resolve one pack-relative asset path against the bundle's asset base.
 *
 * @param carrier - Anything carrying the bundle's `assetBaseUrl` (the runtime manifest)
 * @param assetPath - The pack-relative path as authored
 * @returns The URL to fetch
 */
export const resolvePackAssetUrl = (carrier: AssetBaseCarrier, assetPath: string): string =>
	carrier.assetBaseUrl === undefined ? assetPath : carrier.assetBaseUrl + assetPath;
